// Unique ID for each tab
window.__ECOM_TAB_ID__ = window.__ECOM_TAB_ID__ || Math.random().toString(36).substring(2);

class ecomBroadcast {

  constructor(channelName) {
    this.channel = new BroadcastChannel(channelName);

    this.tabId = window.__ECOM_TAB_ID__;

    this.channel.onmessage = this.receiveMessage.bind(this);
  }

  sendMessage(message){
    this.channel.postMessage({
      ...message,
      sender: this.tabId
    });
  }

  receiveMessage(event) {

    // Ignore messages from self
    if (event.data.sender === this.tabId) return;

    console.log("event received in broadcast");
    console.log(event);

    if(event.data.runFunction){
      this.runFunction(event.data);
    }
  }

  runFunction(eventData){
    if(eventData.type == "locationOpen"){
      locationPickerManager.openLocationPicker()
    }

    if(eventData.type == "locationClose") {
      locationPickerManager.closeAllOpenPickers();
      locationPickerManager.loadLocationData(true);
    }

    if(eventData.type == "cartUpdated") {
      window.location.reload();
    }

    if(eventData.type == "ecom_cart_items:update") {
      console.log("ecom_cart_items:update triggered from top")
      document.dispatchEvent(new CustomEvent("ecom_cart_items:update", {bubbles: true}));
    }
  }
}


// clear cookies
function deleteAllCookies() {
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;

    // Delete the cookie by setting its expiration in the past
    document.cookie = name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
  }
}